function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.1172 7.55913L16.735 6.94137C17.2444 6.43228 17.522 5.73613 17.5028 5.01621C17.4836 4.29629 17.1691 3.61595 16.6333 3.13479C15.5351 2.21609 13.9131 2.30423 12.9209 3.33654L12.4082 3.85009",
  stroke: "#7367F0",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M10.5525 5.70703L9.93475 6.32479C9.42536 6.83388 9.14772 7.53004 9.16695 8.24995C9.18619 8.96987 9.50061 9.65021 10.0365 10.1314C11.1348 11.0503 12.7571 10.9617 13.7488 9.92879L14.2615 9.41608",
  stroke: "#7367F0",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M17.5043 9.99922V14.1676C17.5043 16.0093 16.0113 17.5023 14.1696 17.5023H5.83277C3.99105 17.5023 2.49805 16.0093 2.49805 14.1676V5.83082C2.49805 3.9891 3.99105 2.49609 5.83277 2.49609H10.0012",
  stroke: "#7367F0",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M14.8806 5.08594L11.791 8.17639",
  stroke: "#7367F0",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgAttachment = function SvgAttachment(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAttachment, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/attachment.2682fa07.svg";
export { ForwardRef as ReactComponent };